import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=53883a1c&scoped=true"
import script from "./StarRating.vue?vue&type=script&setup=true&lang=js"
export * from "./StarRating.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StarRating.vue?vue&type=style&index=0&id=53883a1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53883a1c",
  null
  
)

export default component.exports